module.exports = __webpack_public_path__ + "static/media/StatsIcon02.05a723f7.svg";